import { render, staticRenderFns } from "./pricelists.vue-select.vue?vue&type=template&id=02f86636&"
import script from "./pricelists.vue-select.vue?vue&type=script&lang=ts&"
export * from "./pricelists.vue-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports